<template>
  <section class="world-background">
    <cards-roulette :options="options" :type="'program_currency_types'" />
  </section>
</template>

<script>
import ProgramCurrencyTypes from '@/constants/program_currency_types.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'


export default {
  mixins: [OnBoardStepMixin],
  components: { CardsRoulette },
  data() {
    return {
      options: ProgramCurrencyTypes
    }
  }
}
</script>

<style lang="scss">
  @import '~@/scss/_mixins.scss';
  .world-background {
    background: url('~@/assets/hologram-map-background.svg') no-repeat;
    background-size: contain;
    background-position: center;
  }
  </style>